// export const DOMAIN = "https://laguialocal.com.ar";

//const API_BASE = "http://localhost:3002";
const API_BASE = "https://api.laguialocal.com.ar";

export const GRAPHQL_URL = `${API_BASE}/graphql`;
export const URL_MAIL = `${API_BASE}/contacto`;
export const URL_LOCATION = `${API_BASE}/location`;
